<template>
  <printed-form-card v-if="generatedPrintedForm">
    <div>
      <div class="font-weight-bold mb-3">{{ label }}</div>

      <v-chip
        v-if="generatedPrintedForm.status === 'completed'"
        style="width: fit-content"
        density="compact"
        color="success"
        variant="tonal">
        <v-icon icon="mdi-check-circle-outline" class="mr-2"></v-icon>
        <span>
          Сформовано
          {{
            new CustomDate(generatedPrintedForm.created_at).toString({
              time: true,
            })
          }}
        </span>
      </v-chip>
      <v-chip
        v-if="generatedPrintedForm.status === 'inProgress'"
        style="width: fit-content"
        density="compact"
        color="warning"
        variant="tonal">
        <v-icon icon="mdi-progress-clock" class="mr-2"></v-icon>
        <span>У процесі формування</span>
      </v-chip>
      <v-chip
        v-if="generatedPrintedForm.status === 'error'"
        style="width: fit-content"
        density="compact"
        color="error"
        variant="tonal">
        <v-icon icon="mdi-alert-circle-outline" class="mr-2"></v-icon>
        <span>Помилка</span>
      </v-chip>
    </div>

    <v-btn
      density="comfortable"
      :disabled="generatedPrintedForm.status !== 'completed'"
      @click="downloadPrintedForm()">
      Завантажити звіт
    </v-btn>
  </printed-form-card>
</template>

<script lang="ts">
import PrintedFormCard from '../components/PrintedFormCard.vue'
import { PropType } from 'vue'
import { GeneratedPrintedForm } from '@/utils/types'
import { CustomDate, download, getFile } from 'best-modules/utils'

export default {
  name: 'PrintedFormResultItem',
  components: { PrintedFormCard },
  props: {
    generatedPrintedForm: {
      type: Object as PropType<GeneratedPrintedForm | null>,
    },
    label: {
      type: String,
    },
  },
  methods: { CustomDate },
  setup(props) {
    const downloadPrintedForm = async () => {
      if (props.generatedPrintedForm) {
        const file = (await getFile(props.generatedPrintedForm.url)) as string
        download(file, props.generatedPrintedForm.name)
      }
    }

    return { downloadPrintedForm }
  },
}
</script>

<style scoped lang="scss"></style>
